import { useAuthContext } from "@/features/authentication/useAuthContext";
import type { Database } from "@/lib/database.types";
import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export type RecipeTypeRow = Database["public"]["Tables"]["recipe_types"]["Row"];

export function useGetRecipeTypes() {
    const { user } = useAuthContext();
    const { data, isPending, isError } = useQuery<RecipeTypeRow[]>({
        queryKey: ["recipeTypes"],
        queryFn: async () => {
            const { data, error } = await supabase.from("recipe_types").select("*");

            if (error || !data) {
                console.error("Error fetching recipe types:", error);
                throw error;
            }

            const types: RecipeTypeRow[] = data.sort((a, b) => a.name.localeCompare(b.name));
            return types;
        },
        enabled: !!user,
        staleTime: Infinity
    });

    return { data, isPending, isError };
}
